module.exports = __webpack_public_path__ + "img/6.fc0da3b9.jpg";